import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import SEOHead from "@/components/feature/SEOHead";
import ScrollToTop from "@/components/feature/ScrollToTop";
import { testimonials } from "@/mocks/content";
const milestones = [
  { year: "2020", title: "平台创立", desc: "aaa日韩正式上线，致力于打造日韩正版内容聚合平台" },
  { year: "2021", title: "版权合作", desc: "与日本NHK、韩国CJ ENM等头部内容方达成版权合作" },
  { year: "2022", title: "用户破千万", desc: "累计注册用户突破1000万，成为日韩内容领域领先平台" },
  { year: "2023", title: "4K全面升级", desc: "全平台内容支持4K超高清播放，技术实力行业领先" },
  { year: "2024", title: "多终端覆盖", desc: "完成iOS、Android、智能电视全终端覆盖，实现无缝观影" },
  { year: "2025", title: "全球拓展", desc: "服务覆盖全球50+国家和地区，多语言字幕支持" },
  { year: "2026", title: "AI赋能", desc: "引入AI推荐算法，个性化内容推荐精准度提升300%" },
];

export default function About() {
  const [formStatus, setFormStatus] = useState<"idle" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");
  const formUrl = "https://readdy.ai/api/form/d9pmn8mb4qjhggaeq1b0";

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem("phone_alt") as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormStatus("success");
      return;
    }

    if (!formUrl) {
      setFormStatus("error");
      setFormError("表单暂不可用，请稍后再试");
      return;
    }

    try {
      const formData = new FormData(form);
      formData.delete("phone_alt");
      const res = await fetch(formUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed;
      try { parsed = JSON.parse(text); } catch { parsed = null; }

      if (res.ok && parsed?.code === "OK") {
        setFormStatus("success");
        form.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || text || "提交失败";
        if (msg.toLowerCase().includes("spam")) {
          setFormStatus("success");
        } else {
          setFormStatus("error");
          setFormError(msg);
        }
      }
    } catch {
      setFormStatus("error");
      setFormError("网络错误，请稍后重试");
    }
  };

  const aboutSchema = [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "aaa日韩",
      url: "https://www.aaark.com",
      description: "aaa日韩是您探索日韩优质内容的首选平台，汇聚海量日韩正版资源",
      foundingDate: "2020",
      contactPoint: {
        "@type": "ContactPoint",
        contactType: "customer service",
        email: "support@aaark.com",
        availableLanguage: ["Chinese", "Japanese", "Korean"],
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      name: "关于aaa日韩 - 正版日韩内容平台",
      url: "https://www.aaark.com/about",
    },
  ];

  return (
    <>
      <SEOHead
        title="关于我们 - aaa日韩官方正版平台 | 品牌介绍与联系方式"
        description="aaa日韩官方正版授权平台，了解aaa日韩品牌故事、发展历程、用户口碑。我们致力于提供日韩正版高清内容，每日持续更新，多终端同步播放。联系我们获取更多信息。"
        keywords="关于aaa日韩,aaa日韩平台介绍,日韩正版平台,联系我们,品牌故事,aaa日韩口碑"
        canonicalUrl="https://www.aaark.com/about"
        schemaJson={aboutSchema}
      />
      <ScrollToTop />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-16">
          <Breadcrumb
            items={[
              { label: "首页", to: "/" },
              { label: "关于我们" },
            ]}
          />

          {/* Hero */}
          <section className="relative h-[320px] md:h-[400px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20modern%20office%20space%20with%20Japanese%20minimalist%20design%20elements%2C%20warm%20natural%20lighting%20through%20large%20windows%2C%20subtle%20Korean%20aesthetic%20touches%2C%20clean%20sophisticated%20atmosphere%2C%20professional%20corporate%20environment%2C%20soft%20neutral%20colors&width=1600&height=450&seq=about-hero&orientation=landscape"
              alt="aaa日韩品牌介绍"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
            <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
              <h1 className="text-3xl md:text-4xl font-bold text-white mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                关于 aaa<span className="text-primary-400">日韩</span>
              </h1>
              <p className="text-base text-white/70 max-w-xl">
                正版授权，品质保障，用心打造极致的日韩内容体验
              </p>
            </div>
          </section>

          {/* Brand Introduction */}
          <section className="py-14 md:py-20">
            <div className="px-4 md:px-6 max-w-4xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
                  品牌故事
                </h2>
                <p className="text-sm text-foreground-600 mt-2">我们的使命与愿景</p>
              </div>

              <div className="space-y-6 text-base text-foreground-700 leading-relaxed">
                <p>
                  <strong>aaa日韩</strong>成立于2020年，是一家专注于日韩正版内容聚合与分发的综合性在线平台。自创立以来，我们始终秉持"正版授权、品质至上"的核心理念，致力于为中国及全球用户提供最优质、最全面的日韩影视、综艺、动漫、音乐等正版内容资源。
                </p>
                <p>
                  我们与日本NHK、TBS、富士电视台、东映动画以及韩国CJ ENM、JTBC、tvN等数十家头部内容制作公司和版权方建立了长期稳定的合作关系。平台所有内容均获得正版授权，确保每一位用户都能放心观看，享受最纯正的日韩文化盛宴。
                </p>
                <p>
                  在技术层面，aaa日韩持续投入研发资源，采用领先的视频压缩与传输技术，实现4K超高清画质下的流畅播放。我们的AI智能推荐系统能够精准理解用户偏好，为每位用户提供个性化的内容推荐，让发现好内容变得更加简单。
                </p>
                <p>
                  展望未来，aaa日韩将继续深耕日韩内容领域，拓展更多元的内容品类，提升用户体验，努力成为全球日韩文化爱好者最信赖的首选平台。我们相信，好的内容值得被更多人看见，而这正是aaa日韩存在的意义。
                </p>
              </div>
            </div>
          </section>

          {/* Milestones */}
          <section className="py-14 md:py-20 bg-background-100">
            <div className="px-4 md:px-6 max-w-4xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
                  发展历程
                </h2>
                <p className="text-sm text-foreground-600 mt-2">一路走来的重要里程碑</p>
              </div>

              <div className="relative">
                <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-secondary-200 transform md:-translate-x-px"></div>
                <div className="flex flex-col gap-8">
                  {milestones.map((item, index) => (
                    <div
                      key={item.year}
                      className={`relative flex items-start gap-6 ${
                        index % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
                      }`}
                    >
                      <div className="absolute left-4 md:left-1/2 w-3 h-3 rounded-full bg-primary-500 transform -translate-x-1.5 md:-translate-x-1.5 mt-2 z-10 ring-4 ring-background-100"></div>
                      <div className={`pl-10 md:pl-0 md:w-1/2 ${index % 2 === 0 ? "md:pr-12 md:text-right" : "md:pl-12"}`}>
                        <span className="inline-block px-2 py-0.5 text-xs font-bold rounded bg-primary-100 text-primary-700 mb-2">
                          {item.year}
                        </span>
                        <h3 className="text-base font-semibold text-foreground-950 mb-1">{item.title}</h3>
                        <p className="text-sm text-foreground-600">{item.desc}</p>
                      </div>
                      <div className="hidden md:block md:w-1/2"></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* Testimonials */}
          <section className="py-14 md:py-20">
            <div className="px-4 md:px-6 max-w-4xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
                  用户口碑
                </h2>
                <p className="text-sm text-foreground-600 mt-2">听听用户怎么说</p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {testimonials.map((testimonial, index) => (
                  <div key={index} className="p-6 rounded-lg bg-background-100">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: testimonial.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                      "{testimonial.comment}"
                    </p>
                    <div className="flex items-center gap-3">
                      <img
                        src={testimonial.avatar}
                        alt={testimonial.name}
                        className="w-10 h-10 rounded-full object-cover"
                      />
                      <div>
                        <p className="text-sm font-medium text-foreground-950">{testimonial.name}</p>
                        <p className="text-xs text-foreground-500">{testimonial.location}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Contact */}
          <section id="contact" className="py-14 md:py-20 bg-background-100">
            <div className="px-4 md:px-6 max-w-2xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
                  联系我们
                </h2>
                <p className="text-sm text-foreground-600 mt-2">如有任何问题或合作意向，欢迎与我们联系</p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
                <div className="p-5 rounded-lg bg-background-50 text-center">
                  <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-full bg-primary-100">
                    <i className="ri-mail-line text-primary-500"></i>
                  </div>
                  <p className="text-xs text-foreground-500">客服邮箱</p>
                  <p className="text-sm font-medium text-foreground-950">support@aaark.com</p>
                </div>
                <div className="p-5 rounded-lg bg-background-50 text-center">
                  <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-full bg-accent-100">
                    <i className="ri-phone-line text-accent-500"></i>
                  </div>
                  <p className="text-xs text-foreground-500">客服热线</p>
                  <p className="text-sm font-medium text-foreground-950">400-888-9999</p>
                </div>
                <div className="p-5 rounded-lg bg-background-50 text-center">
                  <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-full bg-secondary-200">
                    <i className="ri-time-line text-secondary-500"></i>
                  </div>
                  <p className="text-xs text-foreground-500">服务时间</p>
                  <p className="text-sm font-medium text-foreground-950">每日 9:00-24:00</p>
                </div>
              </div>

              {formStatus === "success" ? (
                <div className="p-6 rounded-lg bg-accent-100/70 text-center">
                  <i className="ri-check-line text-3xl text-accent-500 mb-2 block"></i>
                  <p className="text-sm font-medium text-accent-800">提交成功！我们将尽快与您联系</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-4" data-readdy-form="">
                  <div>
                    <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-800 mb-1.5">
                      姓名
                    </label>
                    <input
                      id="contact-name"
                      name="name"
                      type="text"
                      required
                      className="w-full px-4 py-2.5 text-sm rounded-md border border-background-300 bg-background-50 text-foreground-950 focus:outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-800 mb-1.5">
                      邮箱
                    </label>
                    <input
                      id="contact-email"
                      name="email"
                      type="email"
                      required
                      className="w-full px-4 py-2.5 text-sm rounded-md border border-background-300 bg-background-50 text-foreground-950 focus:outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-800 mb-1.5">
                      留言
                    </label>
                    <textarea
                      id="contact-message"
                      name="message"
                      required
                      maxLength={500}
                      rows={4}
                      className="w-full px-4 py-2.5 text-sm rounded-md border border-background-300 bg-background-50 text-foreground-950 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                      placeholder="请输入您的留言（500字以内）"
                    ></textarea>
                    <p className="text-xs text-foreground-400 mt-1">最多500字</p>
                  </div>
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="honeypot-field"
                  />
                  {formStatus === "error" && (
                    <p className="text-sm text-red-500">{formError}</p>
                  )}
                  <button
                    type="submit"
                    className="w-full px-6 py-3 text-sm font-semibold rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
                  >
                    提交留言
                  </button>
                </form>
              )}
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}